export var a11y = {
    ariaLiveCharCount: function (remaining, max) {
        return "".concat(remaining, " out of ").concat(max, " characters remaining");
    },
};
//# sourceMappingURL=strings.js.map